<ng-template #loading>
    <app-component-loading></app-component-loading>
</ng-template>

<ng-container *ngIf="profile else loading">
    <div class="p-3 profile-wrapper gbo_shadow">
        <div class="profile-header">
            <div class="profile-avatar">
                <app-avatar
                        *ngIf="!loadingAvatar else loading"
                        [profile]="profile"
                        [detailProfile]="true"
                        [size]="'full'"

                        (hasAvatar)="hasAvatar = $event"
                ></app-avatar>

                <button *ngIf="hasAvatar"
                        class="delete-avatar"
                        (click)="deleteAvatar()"
                >
                    <i class="bi bi-trash"></i>
                </button>
                <button class="update-avatar"
                        (click)="modalService.openTemplateModal(uploadPhoto)"
                >
                    {{ 'USER_PROFILE.BUTTONS.CHANGE_PHOTO' | translate }}
                </button>
            </div>
            <div class="profile-info">
                <p>
                    <b>{{ 'USER_PROFILE.TEXT.LASTNAME' | translate }}: </b>
                    {{ profile.lastname }}
                </p>
                <p>
                    <b>{{ 'USER_PROFILE.TEXT.FIRSTNAME' | translate }}: </b>
                    {{ profile.firstname }}
                </p>
                <p>
                    <b>{{ 'USER_PROFILE.TEXT.MIDDLENAME' | translate }}: </b>
                    {{ profile.middlename }}
                </p>
                <p>
                    <b>{{ 'USER_PROFILE.TEXT.EMAIL' | translate }}: </b>
                    {{ profile.email }}
                </p>
                <p>
                    <b>{{ 'USER_PROFILE.TEXT.PHONE' | translate }}: </b>
                    {{ profile.phone }}
                </p>
                <p>
                    <b>{{ 'USER_PROFILE.ROLE.ROLE' | translate }}: </b>
                    {{ 'USER_PROFILE.ROLE.' + profile.project_setting.observation_type | translate }}
                </p>
                <p>
                    <b>{{ 'USER_PROFILE.TEXT.POSITION' | translate }}: </b>
                    {{ profile.project_setting.position }}
                </p>
            </div>
            <div data-action='editProfile'
                 (click)="modalService.openTemplateModal(editProfileView)"
                 class="settings"
            >
                <i class="bi bi-gear-fill sdm_style_text"></i>
            </div>
        </div>
    </div>

    <h2 style="margin-top: 50px;"
        *ngIf="myCompanies.length">{{ 'USER_PROFILE.TEXT.MY_COMPANY' | translate }}:</h2>
    <div class="projects-list">
        <div class="items gbo_shadow"
             (click)="goLink(prj)"
             data-action='changeProject'
             [attr.data-project-guid]="prj.project.guid"
             [class.select]="prj.project.guid === selectedProject"
             *ngFor="let prj of myCompanies"
        >
            <div class="image">
                <i *ngIf="prj.project.type === 'organization'"
                   class="bi bi-buildings"></i>
                <i *ngIf="prj.project.type === 'person'"
                   class="bi bi-person-square"></i>
            </div>
            <div class="name">
                <h2>{{ prj.project.name }}</h2>
                <i>{{ prj.project.domain }}</i>
                <p>
                    <b>{{ 'USER_PROFILE.ROLE.ROLE' | translate }}: </b>
                    {{ 'USER_PROFILE.ROLE.' + prj.observation_type | translate }}
                </p>
                <p *ngIf="prj.position">
                    <b>{{ 'USER_PROFILE.TEXT.POSITION' | translate }}: </b>
                    {{ prj.position }}
                </p>
            </div>
        </div>
    </div>

    <h2 style="margin-top: 50px;"
        *ngIf="contrAgents.length">{{ 'USER_PROFILE.TEXT.COUNTERPARTIES' | translate }}:</h2>
    <div class="projects-list">
        <div class="items gbo_shadow"
             (click)="goLink(prj)"
             data-action='changeProject'
             [attr.data-project-guid]="prj.project.guid"
             [class.select]="prj.project.guid === selectedProject"
             *ngFor="let prj of contrAgents"
        >
            <div class="image">
                <i *ngIf="prj.project.type === 'organization'"
                   class="bi bi-buildings"></i>
                <i *ngIf="prj.project.type === 'person'"
                   class="bi bi-person-square"></i>
            </div>
            <div class="name">
                <h2>{{ prj.project.name }}</h2>
                <i>{{ prj.project.domain }}</i>
                <p>
                    <b>{{ 'USER_PROFILE.ROLE.ROLE' | translate }}: </b>
                    {{ 'USER_PROFILE.ROLE.' + prj.observation_type | translate }}
                </p>
                <p *ngIf="prj.position">
                    <b>{{ 'USER_PROFILE.TEXT.POSITION' | translate }}: </b>
                    {{ prj.position }}
                </p>
            </div>
        </div>
    </div>

    <h2 style="margin-top: 50px;">{{ 'USER_PROFILE.TEXT.CONTRACTS' | translate }}:</h2>
    <app-contracts-table
            [filter]="'my'"
            [isInProfile]="true"
            [isNavigate]="false"
            [profile]="profile"
            (emitEventSelected)="goLink($event.master_project, $event)"
    ></app-contracts-table>
</ng-container>

<ng-template #editProfileView
             let-modal>
    <app-button-modal-close [modal]="modal"
                            (closeEmit)="newPin = oldPin = newExtraPin = oldExtraPin = null"></app-button-modal-close>
    <div class="modal-body flex-display">
        <div class="super__tabs vertical">
            <div class="super__tabs tab"
                 (click)="tab = 'profile'"
                 data-action="profile"
                 [class.active]="tab === 'profile'"
            >
                <span class="profile-tab">{{ 'MODALS.HEADERS.PROFILE' | translate }}</span>
            </div>
            <div class="super__tabs tab"
                 (click)="tab = 'security'"
                 data-action="security"
                 [class.active]="tab === 'security'"
            >
                <span class="profile-tab">{{ 'MODALS.HEADERS.SECURITY' | translate }}</span>
            </div>
        </div>
        <div class="ml-30px">
            <ng-container *ngIf="tab === 'profile'">
                <ng-container *ngTemplateOutlet="editProfile"></ng-container>
            </ng-container>
            <ng-container *ngIf="tab === 'security'">
                <ng-container *ngTemplateOutlet="security"></ng-container>
            </ng-container>
        </div>

        <ng-template #editProfile>
            <div>
                <h1>{{ 'MODALS.HEADERS.EDIT_PROFILE' | translate }}</h1>

                <h2>{{ 'MODALS.FIELDS.LASTNAME' | translate }}</h2>
                <input type="text"
                       autocomplete='new-password'
                       value="{{profile.lastname}}"
                       #lastname>

                <h2 style="margin-top: 20px;">{{ 'MODALS.FIELDS.FIRSTNAME' | translate }}</h2>
                <input type="text"
                       autocomplete="new-password"
                       value="{{profile.firstname}}"
                       #firstname>

                <h2 style="margin-top: 20px;">{{ 'MODALS.FIELDS.MIDDLENAME' | translate }}</h2>
                <input type="text"
                       autocomplete="new-password"
                       value="{{profile.middlename}}"
                       #middlename>

                <h2>{{ 'MODALS.FIELDS.PHONE' | translate }}</h2>
                <input #phoneNumber
                       type="tel"
                       value="{{profile.phone}}">

                <h2>{{ 'MODALS.FIELDS.LANGUAGE' | translate }}</h2>
                <select #language
                        class="form-select">
                    <option [selected]="currentLanguage === 'ru'"
                            value="ru">RU
                    </option>
                    <option [selected]="currentLanguage === 'en'"
                            value="en">EN
                    </option>
                </select>

                <button class="btn btn-success mt-30px"
                        data-action="changeProfile"
                        (click)="saveEditProfile(lastname.value, firstname.value, middlename.value, phoneNumber.value, language.value);"
                >
                    <span>{{ 'MODALS.BUTTONS.SAVE_PROFILE' | translate }}</span>
                </button>
            </div>
        </ng-template>

        <ng-template #security>
            <div>
                <h1>{{ 'MODALS.HEADERS.CHANGE_PASS' | translate }}</h1>
                <h2>{{ 'MODALS.FIELDS.OLD_PASS' | translate }}</h2>
                <input type="password"
                       #oldPass
                       autocomplete="new-password">

                <h2 style="margin-top: 20px;">{{ 'MODALS.FIELDS.NEW_PASS' | translate }}</h2>
                <input type="password"
                       autocomplete="new-password"
                       #newPass>

                <h2 style="margin-top: 20px;">{{ 'MODALS.FIELDS.CONFIRM_NEW_PASS' | translate }}</h2>
                <input type="password"
                       autocomplete="new-password"
                       #checkNewPass>

                <button class="btn btn-success mt-30px"
                        data-action="changePass"
                        (click)="changePassword(oldPass.value, newPass.value, checkNewPass.value);"
                >
                    <span>{{ 'MODALS.BUTTONS.CHANGE_PASS' | translate }}</span>
                </button>

                <h1 class="mt-30px">{{ 'MODALS.HEADERS.CHANGE_PIN' | translate }}</h1>
                <h2>{{ 'MODALS.FIELDS.OLD_PIN' | translate }}</h2>
                <app-code-input
                        (codeCompleted)="oldPin = $event"
                ></app-code-input>

                <h2 style="margin-top: 20px;">{{ 'MODALS.FIELDS.NEW_PIN' | translate }}</h2>
                <app-code-input
                        (codeCompleted)="newPin = $event"
                ></app-code-input>

                <button class="btn btn-success mt-30px"
                        (click)="changePin();"
                        data-action="changePinPin"
                >
                    <span>{{ 'MODALS.BUTTONS.CHANGE_PIN' | translate }}</span>
                </button>

                <h1 class="mt-30px">{{ 'MODALS.HEADERS.CHANGE_EXTRA_PIN' | translate }}</h1>
                <h2>{{ 'MODALS.FIELDS.OLD_EXTRA_PIN' | translate }}</h2>
                <app-code-input
                        (codeCompleted)="oldExtraPin = $event"
                ></app-code-input>

                <h2 style="margin-top: 20px;">{{ 'MODALS.FIELDS.NEW_EXTRA_PIN' | translate }}</h2>
                <app-code-input
                        (codeCompleted)="newExtraPin = $event"
                ></app-code-input>

                <button class="btn btn-success mt-30px"
                        data-action="changeExtraPin"
                        (click)="changeExtraPin();"
                >
                    <span>{{ 'MODALS.BUTTONS.CHANGE_EXTRA_PIN' | translate }}</span>
                </button>
            </div>
        </ng-template>
    </div>
</ng-template>


<ng-template #uploadPhoto
             let-modal>
    <app-button-modal-close [modal]="modal"
                            (closeEmit)="selectedImage = null"></app-button-modal-close>
    <div class="modal-body">
        <h1>Загрузить аватар профиля</h1>
        <span>Поддерживается форматы .jpg, .jpeg, .png, .gif</span>

        <div>
            <strong *ngIf="image.files.length"><i>{{ image.files[0].name }}</i><br></strong>
            <input (change)="viewImageUpload(image.files[0])"
                   style="display: none"
                   type="file"
                   accept=".png, .jpeg, .jpg, .gif"
                   #image>
            <button class="btn btn-primary mt-1"
                    (click)="image.click(); selectedImage = null">
                <span>Выбрать файл</span>
            </button>
        </div>
        <div>
            <img id="output"
                 src="#"
                 width="150"
                 height="150"
                 style="margin-top: 25px; object-fit: cover;"
                 class="{{selectedImage ? 'display_block' : 'display_none'}}"
                 alt="">
        </div>


        <button *ngIf="image.files.length"
                (click)="changeAvatar(image.files[0], modal)"
                class="btn btn-success mt-3">
            <span>Сохранить</span>
        </button>
    </div>
</ng-template>
